import type { Session } from '@eventbrite/checkout-fairy-api';
import { EventStatus } from '../../../constants/eventStatus';

export const getFirstAvailableSession = (sessions: Session[] | undefined) => {
    const sortedSessions = sessions?.sort((a, b) =>
        (a.startDatetime ?? '').localeCompare(b.startDatetime ?? ''),
    );

    return sortedSessions?.find(
        (session) => session.availability !== EventStatus.soldOut,
    );
};
